<template>
  <div v-if="source">
    <div v-if="loading" class="loading">
      <h5>A Carregar</h5>
      <sub></sub>
    </div>
    <pdf v-else
      v-for="i in numPages"
      :src="source"
      :key="i"
      :page="i"
      class="pdf"
    ></pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfViewer',
  components: {
    pdf
  },
  props: {
    source: {
      type: String,
      default: null
    }
  },
  data: () => ({
    numPages: 1,
    loading: true,
    interval: []
  }),
  methods: {
    async loadPdf() {
      if (this.interval.length >= 1) {
        this.clearLoadInterval()
      }

      try {
        const pdfFile = await pdf.createLoadingTask(this.source).promise
        this.numPages = pdfFile.numPages
        this.loading = false
      } catch (error) {
        // console.log('error', error) //eslint-disable-line
      }
      
      if (this.interval.length > 0) {
        this.clearLoadInterval()
      }
    },
    clearLoadInterval() {
      clearInterval(this.interval[0])
      this.interval = this.interval.slice(1)
    }
  },
  mounted() {
    this.loadPdf()
    this.interval.push(
      setInterval(this.loadPdf, 5000)
    );
  }
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
}

.pdf {

}
</style>
